import { AlertCard, Button, Loader } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import { EditPencil01 } from "@icons";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import classes from "./UserAuthorizationsCard.module.css";
import type { UserAuthorizationsCardProps } from "./UserAuthorizationsCard.types";
import { AccessManagerCard } from "../AccessManagerCard/AccessManagerCard";

export const UserAuthorizationsCard: FC<UserAuthorizationsCardProps> = ({
  isAdmin,
  customerIdsCount,
  onClick,
  isLoading,
}) => {
  const { t } = useCustomTranslation(["main", "common"]);

  if (isLoading) {
    return (
      <AccessManagerCard
        dataTestId="card-user-authorizations"
        title={t("userDetails.authorization.title")}
      >
        <Loader />
      </AccessManagerCard>
    );
  }

  return (
    <AccessManagerCard
      dataTestId="card-user-authorizations"
      title={t("userDetails.authorization.title")}
    >
      <div className={classes.row}>
        <span>
          {t("userDetails.authorization.access", {
            count: customerIdsCount,
          })}
        </span>
        {!isAdmin && (
          <Button
            data-testid="button-edit-user-authorizations"
            onClick={onClick}
            startIcon={EditPencil01}
            variant="secondary"
          >
            {t("button.edit", { ns: "common" })}
          </Button>
        )}
      </div>
      {isAdmin && (
        <AlertCard>
          <AlertCard.Description>
            {t("userDetails.authorization.admin")}
          </AlertCard.Description>
        </AlertCard>
      )}
    </AccessManagerCard>
  );
};
